import {
  GET_CONTINGENCY_OPTIONS,
  GET_CONTINGENCY_OPTIONS_ERROR,
  GET_CONTINGENCY_OPTIONS_SUCCESS
} from './Contingencies.actions'

const initialState = {
  contingencyOptions: [],
  contingencySelected: 2,
  error: null,
  loading: false
}

/**
 * Contingencies's reducer.
 */
const contingencies = (state = initialState, { payload, type }) => {
  switch (type) {
    case GET_CONTINGENCY_OPTIONS: {
      return { ...state, loading: true }
    }
    case GET_CONTINGENCY_OPTIONS_ERROR: {
      return { ...state, error: payload.error, loading: false }
    }
    case GET_CONTINGENCY_OPTIONS_SUCCESS: {
      return { ...state, contingencyOptions: payload.options, loading: false }
    }
    default: {
      return state
    }
  }
}

export default contingencies
